import { Component, OnInit } from '@angular/core';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-studentassessmentlist',
  templateUrl: './studentassessmentlist.component.html',
  styleUrls: ['./studentassessmentlist.component.css']
})
export class StudentassessmentlistComponent implements OnInit {

  assessmentsList: any = [];
  assessments: any = [];
  pendingassignment: boolean = true
  submittedassignment: boolean;
  submittedCount = 0;
  pendingCount = 0;

  constructor(private assessmentManager: AssessmentmanagerService, private headerinfo: ComponentheaderService, private util: UtilService) {
    this.headerinfo.setHeaderDisplay('Assessment Widget', [], []);
  }

  async ngOnInit() {
    if(await this.util.hasFeature(FeatureGroups.ASSESSMENTS)){
      this.assessmentsList = await this.assessmentManager.getAssessmentsForStudent();
    }
    else{
      this.assessmentsList = [];
    }

    
    this.assessments = this.assessmentsList.filter((assessment) => {
      //debugger;
      if (assessment.submitted) {
        this.submittedCount++;
      } else {
        this.pendingCount++;
      }
      return !assessment.submitted

    })
  }

  showsubmittedassessments() {
    this.assessments = this.assessmentsList.filter(function (assessment) { return assessment.submitted })
    this.submittedassignment = true;
    this.pendingassignment = false;
  }

  showpendingassessments() {
    this.assessments = this.assessmentsList.filter(function (assessment) { return !assessment.submitted })
    this.pendingassignment = true
    this.submittedassignment = false
  }
  resetCounters() {
    this.pendingCount = 0;
    this.submittedCount = 0;
  }




}
